import { Button$PressEvent } from "sap/m/Button";
import Controller from "sap/ui/core/mvc/Controller";
import Util from "ips/ac/util/Util";
import Fragment from "sap/ui/core/Fragment";
import BaseTypedController from "ips/ac/base/controller/BaseTypedController";
import Control from "sap/ui/core/Control";
import ManagedObject from "sap/ui/base/ManagedObject";
import JSONModel from "sap/ui/model/json/JSONModel";

export default {
  async openFragmentPopup(controller: BaseTypedController, oEvent: Button$PressEvent) {
    const oSource = oEvent.getSource();
    const sId = oSource.getId();
    const oDomRef = oEvent.getParameter("domRef");
    const sName = oSource.data("fragmentName");
    const oFragment = await this.getFragment(sName, controller);
    const sCallback = oSource.data("callback");


    // todo should be executed in the extending controller before calling openFragmentPopup
    if (
      sId.match("createNewFilterDialog") ||
      sId.match("createNewTeamFilterDialog")
    ) {
      const model = controller.getModel<JSONModel>("ui");
      model.setProperty("/mode", "create");
      model.setProperty("/dialogTitle", Util.getText("@FilterFilterCreate"));
      controller._setFilterDialogValues("", false, false);
    } else if (sId.match("openFilterManager")) {
      controller._bindFilterDialogList();
    }

    // apply source binding to fragment to allow use of relative binding changes
    if (oSource.data("applySourceBinding")) {
      oFragment.bindElement(oSource.getBindingContext().getPath());
    }

    // delay because addDependent (inside getFragement) will do a async rerendering and the popover will immediately close without it
    jQuery.sap.delayedCall(0, this, function() {
      if (oFragment.openBy) {
        // popover
        oFragment.openBy(oDomRef ? oDomRef : oSource);
      } else {
        // dialog
        oFragment.open();
      }
    });

    if (sCallback && typeof controller[sCallback] === "function") {
      controller[sCallback](oEvent, oFragment);
    }
  },

  closePopup(oEvent: Button$PressEvent, oTarget?: ManagedObject) {
    let oNode = oTarget ? oTarget : oEvent.getSource();

    while (oNode !== null && !oNode.close) {
      oNode = oNode.getParent();
    }

    if (oNode && oNode.close) {
      if (
        oEvent.getSource() &&
        oEvent.getSource().data("clearFilters") === "All"
      ) {
        const arElements = oNode.findElements(true);
        arElements.forEach((oElement) => {
          if (oElement.isA("sap.m.SearchField")) {
            oElement.setValue("");
          } else if (oElement.isA("sap.m.MultiComboBox")) {
            oElement.removeAllSelectedItems();
          }
        });
      }
      oNode.close();
    }
  },

  async getFragment(sId: string, controller: Controller): Promise<Control> {
    let sName = sId;
    const oView = controller.getView();
    const sFragmentId = oView.getId();
    const sCacheId = sFragmentId + "--" + sName;
    const component = Util.getComponent();

    let fragment = component._mFragments[sCacheId];
    if (fragment) {
      return fragment;
    }

    fragment = await component.runAsOwner(() => Fragment.load({ name: sName, id: sFragmentId, controller: controller }));

    component._mFragments[sCacheId] = fragment;
    oView.addDependent(fragment);

    // toggle compact style
    jQuery.sap.syncStyleClass(
      "sapUiSizeCompact",
      oView,
      fragment,
    );

    return fragment;
  },
};

